import { UUID } from "./common";
import { UserStatus } from "./users";

export enum UserRole {
    SuperAdmin = "ROLE_SUPER_ADMIN",
    Admin = "ROLE_ADMIN",
    HSBCOperator = "ROLE_HSBC_OPERATOR",
    PO = "ROLE_PROJECT_OFFICER",
    Contractor = "ROLE_MAIN_CONTRACTOR",
    FinanceDepartment = "ROLE_FINANCE_DEPARTMENT",
    ClaimApprover = "ROLE_CLAIM_APPROVER",
    PaymentOrderApprover = "ROLE_PAYMENT_ORDER_APPROVER",
    // TODO: BE has removed these two roles, check if there are any functions in FE that need these and refactor
    Architect = "ROLE_ARCHITECT",
    Director = "ROLE_DIRECTOR",
}

export type Authority = {
    authority: UserRole;
};

export type UserCurrent = {
    authorities: Authority[];
    email: string;
    id: UUID;
    username: string;
    fullName: string;
    role?: string;
    lastName?: string;
    firstName?: string;
    status?: UserStatus;
    userProfile?: any;
    isProfilemanagementEnabled?: boolean;
    isUsermanagementEnabled?: boolean;
    enableInvEmailNotif?: boolean;
    admin?: boolean;
    tokenUser?: boolean;
    accountNonExpired?: boolean;
    accountNonLocked?: boolean;
    credentialsNonExpired?: boolean;
};

export type Party = {
    partyName?: string;
    companyName?: string;
}